<script setup lang="ts">
import PolicySupportedVersionsTemplate from '~/components/templates/PolicySupportedVersionsTemplate/PolicySupportedVersionsTemplate.vue';

useAppMeta({
  title: '推奨環境',
});
</script>

<template>
  <PolicySupportedVersionsTemplate />
</template>

<style lang="scss" module></style>
